import { FontConfig } from "../types"

export const BODY_BASE_CONFIG: FontConfig = {
  title: "BODY/base",
  mobile: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Regular", tw: "font-normal" },
    size: { px: 14, tw: "text-[14px]" },
    lineHeight: { px: 20, tw: "leading-[20px]" },
  },
  tablet: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Regular", tw: "font-normal" },
    size: { px: 15, tw: "text-[15px]" },
    lineHeight: { px: 24, tw: "leading-[24px]" },
  },
  desktop: {
    family: { value: "DM Sans", tw: "font-sans" },
    weight: { value: "Regular", tw: "font-normal" },
    size: { px: 18, tw: "text-[18px]" },
    lineHeight: { px: 24, tw: "leading-[24px]" },
  },
}
